import type { OrganisationPeriodJobsLocales } from '../types';

const organisationPeriodJobsLocales: OrganisationPeriodJobsLocales = {
  accepted: 'Geaccepteerd',
  assignmentDetails: 'Opdracht details',
  assignmentInfo: 'Opdracht informatie',
  assignments: 'Opdrachten',
  availability: 'Beschikbaarheid',
  available: 'Beschikbaar',
  back: 'Terug',
  byEndDate: 'Op einddatum',
  byLocation: 'Op locatie',
  byStartDate: 'Op startdatum',
  cancelAssignment: 'Opdracht annuleren',
  cancelled: 'Geannuleerd',
  cancelPeriodJob: 'Opdracht verbergen',
  certificates: 'Certificaten',
  clearOrdering: 'Sortering verwijderen',
  clickConvertToProceed: 'Klik op omzetten om door te gaan.',
  clickToProceed: 'Klik op "{{action}}" om de opdracht te {{action}}',
  close: 'Sluiten',
  closed: 'Gesloten',
  competences: 'Competenties',
  confirm: 'Bevestigen',
  confirmAction: 'Bevestig actie',
  confirmCloseJob:
    'Wilt u deze lange opdracht sluiten? Freelancers kunnen de opdracht dan niet meer zien en ook geen interesse meer tonen. Gebruik dit wanneer genoeg freelancers interesse hebben getoond.',
  confirmConvertJob: 'Wilt u deze opdracht omzetten in spoed?',
  confirmed: 'Bevestigd',
  confirmedJobFirst: 'Bevestigde eerst',
  confirmFreelancer: 'Freelancer bevestigen',
  confirmFreelancerMessage:
    'Wilt u deze freelancer uitnodigen voor de lange opdracht?',
  confirmHideJob:
    'Wil je deze lange opdracht verbergen? Gebruik dit wanneer de opdracht niet meer nodig is. Deze is dan niet meer zichtbaar voor u, en u kunt de opdracht niet meer zichtbaar maken.',
  convert: 'Omzetten',
  converted: 'Omgezet',
  convertedToUrgent: 'Omgezet naar urgent',
  convertToUrgent: 'Omzetten naar spoed',
  dashboard: 'Dashboard',
  date: 'Datum',
  days: 'Dagen',
  detailsAndConfirm: 'Details & bevestigen',
  documents: 'Documenten',
  edit: 'Bewerken',
  editAssignment: 'Opdracht bewerken',
  endDate: 'Einddatum',
  endTime: 'Eindtijd',
  expired: 'Verlopen',
  explanation: 'Toelichting',
  freelancer: 'Freelancer',
  freelancerAvailabilityStats:
    ' {{available}} van de {{total}} diensten ({{perc}}%)',
  freelancerAvailabilityText: 'Freelancer is beschikbaar voor ',
  freelancerProfile: 'Bekijk profiel',
  freelancers: 'Freelancers',
  freelancersListHelpText:
    'Deze freelancers hebben interesse getoond. Bekijk hun profielen of kies iemand om de diensten te vervullen.',
  hide: 'Verbergen',
  info1:
    'Je voert de details van de dienst in, de locatie en voor welke periode.',
  info1Title: 'Dienst plaatsen. ',
  info2: 'De freelancers zien de dienst en kunnen interesse tonen.',
  info2Title: 'Kandidaten zoeken. ',
  info3:
    'Je ziet de geinteresseerde pedagogisch professionals en kunt contact opnemen.',
  info3Title: 'Kennismaken (Optioneel)',
  info4: 'Wijs een kandidaat toe aan de diensten.',
  info4Title: 'Toewijzen. ',
  invitedFreelancers: 'Uitgenodigde freelancers',
  inviteFreelancer: 'Nodig een andere freelancer uit',
  jobCancelled: 'Opdracht geannuleerd!',
  JobConfirm: 'Opdracht bevestigen',
  jobConverted: 'Opdracht succesvol omgezet naar urgent.',
  jobDetails: 'Opdracht details',
  jobEdited: 'Opdracht succesvol bewerkt!',
  location: 'Locatie',
  maximalTarif: 'Maximaal tarief',
  nb: 'Tip',
  nbContent:
    'Zodra er genoeg kandidaten zijn, kun je de inschrijving sluiten. ',
  newAssignement: 'Nieuwe opdracht',
  noAssignmentFound: 'Geen opdrachten gevonden voor deze lange opdracht.',
  noCertificatesRequired: 'Geen certificaten vereist.',
  noInterestedFreelancers: 'Er hebben nog geen freelancers interesse getoond.',
  notAvailable: 'Niet beschikbaar',
  notFilledIn: 'Niet ingevuld',
  numberIntersted: 'Aantal geïnteresseerde freelancers',
  open: 'Open',
  OpenJobsFirst: 'Openstaande eerst',
  overview: 'Overzicht',
  pause: 'Pauze',
  pending: 'In behandeling',
  period: 'Periode',
  PeriodJobs: 'Langere opdrachten',
  periodJobsDef:
    'Lange opdrachten zijn bedoeld als hulpmiddel om een invaller te vinden voor een langere periode, bijvoorbeeld een zwangerschap.',
  refused: 'Geweigerd',
  remarks: 'Opmerkingen',
  sort: 'Sorteren',
  startDate: 'Startdatum',
  startTime: 'Starttijd',
  status: 'Status',
  time: 'Tijd',
  total: 'Totaal',
};

export default organisationPeriodJobsLocales;
